import { render, staticRenderFns } from "./EditDimension.vue?vue&type=template&id=4af284f1&scoped=true&"
import script from "./EditDimension.vue?vue&type=script&lang=js&"
export * from "./EditDimension.vue?vue&type=script&lang=js&"
import style0 from "./EditDimension.vue?vue&type=style&index=0&id=4af284f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af284f1",
  null
  
)

export default component.exports